// extracted by mini-css-extract-plugin
export default {"marker":"poGbWB","marker--color-navy":"z115TA","marker--color-poppy":"bBuVj3","label":"Pmgd9M"};